import axios from "@axios";

export default {
  generate(data) {
    return axios.post("/profissional/atendimento/parecer_cardiologicos", data);
  },
  salvarExameFisico(data) {
    return axios.put(
      `/profissional/atendimento/parecer_cardiologicos/exame_fisico/${data.id}`,
      data
    );
  },
  salvarSimtomatologia(data) {
    return axios.put(
      `/profissional/atendimento/parecer_cardiologicos/sintomatologia/${data.id}`,
      data
    );
  },
  salvarFatorDeRisco(data) {
    return axios.put(
      `/profissional/atendimento/parecer_cardiologicos/fator_risco/${data.id}`,
      data
    );
  },
  getById(id) {
    return axios.get(`/profissional/atendimento/parecer_cardiologicos/${id}`);
  },
  getPatientById(id) {
    return axios.get(
      `/profissional/atendimento/parecer_cardiologicos/paciente/${id}`
    );
  },
  updateFatorRisco(data) {
    return axios.put(
      `/profissional/atendimento/parecer_cardiologicos/fator_risco/${data.id}`,
      data
    );
  },
  updateSintomaTologia(data) {
    return axios.put(
      `/profissional/atendimento/parecer_cardiologicos/sintomatologia/${data.id}`,
      data
    );
  },
  updateExameFisico(data) {
    return axios.put(
      `/profissional/atendimento/parecer_cardiologicos/exame_fisico/${data.id}`,
      data
    );
  },
  salvarRecomendacao(data) {
    return axios.put(
      `/profissional/atendimento/parecer_cardiologicos/recomendacao/${data.id}`,
      data
    );
  },
  salvarExamesComplementares(data) {
    return axios.put(
      `/profissional/atendimento/parecer_cardiologicos/exame_complementares/${data.id}`,
      data
    );
  },
  salvarConclusao(data) {
    return axios.put(
      `/profissional/atendimento/parecer_cardiologicos/conclusao/${data.id}`,
      data
    );
  },
  salvarMedicamentoEmUso(data) {
    return axios.put(
      `/profissional/atendimento/parecer_cardiologicos/medicamento_em_uso/${data.id}`,
      data
    );
  },
};
